module.exports = __webpack_public_path__ + "static/media/ImageNotFound.aef867ae.png";